import { z } from 'zod'
import { type MobileAppSetting } from '../../models/AppSetting'
import {
  PrintPointRedirectDTO,
  mapDTOToPrintPointRedirect,
  mapPrintPointRedirectToDTO
} from '../../../peripherals/gateways/DTOs/PrintPointRedirectDTO'
import { mapDTOToSlimModel, SlimModelDTO } from '~/domain/shared/slim/gateways/DTOs/SlimModelDTO'

export const MobileAppSettingDTO = z.object({
  print_point_redirects: z.array(PrintPointRedirectDTO).nullish(),
  point_of_sale: SlimModelDTO.nullish(),
  pos_id: z.number().nullish()
})

export type MobileAppSettingDTO = z.infer<typeof MobileAppSettingDTO>

export function mapMobileAppSettingToDTO (model: MobileAppSetting): MobileAppSettingDTO {
  return {
    print_point_redirects: model.redirectEnabled
      ? model.printPointRedirects?.map(printPointRedirect => mapPrintPointRedirectToDTO(printPointRedirect))
      : null,
    pos_id: model.pointOfSale ? model.pointOfSale.id : undefined
  }
}

export function mapDTOToMobileAppSetting (dto: MobileAppSettingDTO): MobileAppSetting {
  return {
    printPointRedirects: dto.print_point_redirects?.map(printPointRedirect =>
      mapDTOToPrintPointRedirect(printPointRedirect)
    ),
    redirectEnabled: (dto.print_point_redirects?.length ?? 0) > 0,
    pointOfSale: dto.point_of_sale ? mapDTOToSlimModel(dto.point_of_sale) : undefined
  }
}
